/**
 * Servicio de retirada de mueble antiguo
 * Confort Liquidación
 *
 * Añade el servicio (variant ID 54895369879881) al carrito junto con el producto
 * principal cuando el cliente marca el checkbox en la página de producto.
 */

(function () {
  'use strict';

  var RETIRADA_VARIANT_ID = 54895369879881;
  var CHECKBOX_ID = 'retirada-mueble-checkbox';

  document.addEventListener('DOMContentLoaded', function () {
    initRetiradaCheckbox();
  });

  function initRetiradaCheckbox() {
    var checkbox = document.getElementById(CHECKBOX_ID);
    if (!checkbox) return;

    // Buscamos el formulario de producto que contiene el checkbox
    var productForm = checkbox.closest('form[action*="/cart/add"]');
    if (!productForm) return;

    productForm.addEventListener('submit', function (event) {
      if (!checkbox.checked) return; // Comportamiento normal

      event.preventDefault();
      handleSubmitWithService(productForm);
    });
  }

  function handleSubmitWithService(form) {
    var formData = new FormData(form);
    var submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }

    // 1) Añadimos el producto principal
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Error al añadir producto');
        return res.json();
      })
      .then(function () {
        // 2) Añadimos el servicio de retirada
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: RETIRADA_VARIANT_ID, quantity: 1 }]
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Error al añadir servicio de retirada');
        return res.json();
      })
      .then(function () {
        // 3) Refrescamos el cart drawer si existe
        refreshCartDrawer();
      })
      .catch(function (err) {
        console.error('[Retirada mueble]', err);
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .finally(function () {
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
      });
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      // Dawn nativo: le pedimos que se renderice con las nuevas líneas
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartDrawer.renderContents({
            sections: null,
            source: 'product-form',
            productVariantId: null,
            cart: cart
          });
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        })
        .catch(function () {
          window.location.href = window.Shopify.routes.root + 'cart';
        });
    } else {
      // No hay cart drawer detectable: vamos al carrito
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  }
})();